<template>
  <div class="zone" v-loading="loading" :element-loading-text="loadingText">
    <functionBox  :titleData="{permission_flag:'SparePart',nowID:1}"
                  @searchBtn="searchBtn" @addCheck="editCheck('1')" :hideSearchBtn = true  @clearSearch="clearSearch" :searhLoading="loading">
      <template>
        <li>
          <el-input placeholder="请输入关键字" v-model="searchParams.keywords" clearable size="small"></el-input>
        </li>

        <li>
          <el-date-picker
              size="small"
              v-model="check_time"
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="marginLeft:10px"
              class="Calendar"
              @clear="clearSearchTime"
          />
        </li>
        <li>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchBtn">搜索</el-button>
        </li>
        <div  class="right" style="margin-top: 10px;text-align: right;width: 43%">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAddExam"   style="text-align: right; background: #1acb64;border:#1acb64">新增考试</el-button>
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAddQuestion"   style="text-align: right; background: #347CAF;border:#347CAF">新增题库</el-button>
        </div>
      </template>
    </functionBox>
    <div class="sheet"  v-loading="loading" :element-loading-text="loadingText">
      <el-table :data="tableData" stripe  :height="tableSize== 'big' ? '960' : tableSize== 'middle' ?'630' : '430'">
        <el-table-column type="index" width="55" label="#"> </el-table-column>
        <el-table-column prop="training_title" label="关联培训项目" min-width="220" align="center"></el-table-column>
        <el-table-column prop="checkTime" label="考试时间"  min-width="280" align="center">
          <template v-slot="{row}">
            <span>{{row.start_time.slice(0,10)}}~{{row.end_time.slice(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="exam_duration" label="考试时长（单位：分钟）"  min-width="150" align="center">
          <template #header>
            <span>考试时长<br>（单位：分钟）</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_scores" label="总分（单位：分）"  min-width="150" align="center">
          <template #header>
            <span>总分<br>（单位：分）</span>
          </template>
        </el-table-column>
        <el-table-column prop="pass_scores" label="合格分数（单位：分）"  min-width="150" align="center">
          <template #header>
          <span>合格分数<br>（单位：分）</span>
        </template>
        </el-table-column>
        <el-table-column prop="exam_times" label="可考次数"  min-width="120" align="center"></el-table-column>
        <el-table-column prop="total_questions" label="考题总数"  min-width="120" align="center"></el-table-column>
        <el-table-column prop="" label="操作" :width="tableSize== 'big' ? '600' : tableSize== 'middle' ?'480' : '340'" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button size="mini" v-if="!row.is_publish" @click="editCheck('2',row)"  class="train-edit-btn">编辑</el-button>
            <el-button size="mini"  v-if="!row.is_publish"  @click="handleUpdateExam(row)"  class="train-update-btn">{{row.is_related_question ? '更新' : '添加' }}考试内容</el-button>
            <el-button size="mini" @click="handleCheck(row)"  class="train-check-btn">查看考试记录</el-button>
            <el-button size="mini" v-if=" !row.is_publish"  @click="handleDelete(row)"  class="train-delete-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="el_pagination_style">
        <el-pagination
            :hide-on-single-page="total <= 0"
            background
            layout="total,sizes,prev, pager, next,jumper"
            :total="total"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="size"
            :current-page.sync="page"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        />
      </div>

      <el-dialog
          :title="dialogType_dept == '1' ? '新增考试' : '编辑考试'"
          v-if="addExamDialog"
          :visible.sync="addExamDialog"
          width="50%"
          custom-class="addDialog"
          @closed="handleClose1"
          >
        <add-exam-dialog ref="addExam"  v-if="addExamDialog" :exam-id="examId"></add-exam-dialog>
        <span slot="footer" class="dialog-footer" style="text-align: center">
           <el-button type="primary" @click="handleExamSave()">确认提交</el-button>
           <el-button @click="handleCloseAdd()">关闭页面</el-button>
        </span>
      </el-dialog>
      <el-dialog
          title="新增/更新考试内容"
          :visible.sync="updateExamDialog"
          width="80%"
          :before-close="handleClose">
        <update-exam-dialog v-if="updateExamDialog"></update-exam-dialog>
        <span slot="footer" class="dialog-footer" style="text-align: center">
           <el-button type="primary" @click="handleConfirmSave()">确认提交</el-button>
          <el-button @click="updateExamDialog = false">关闭页面</el-button>

        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TJDetailTitle from '@/components/TJDetailTitle'
import timePicker from '@/components/timePicker'
// import { hospitals_list,organization_list } from '@/api/search.js'
import FunctionBox from '@/views/Statistics/components/functionBox.vue'
import {addMenu, getAssetMgtBtn} from "@/router/menuMain";
import {getToken} from "@/utils/auth";
import addExamDialog from "@/views/cloudTraining/exam/components/addExamDialog.vue";
import updateExamDialog from "@/views/cloudTraining/exam/updateExam.vue";
import {deleteExam, getExamList, saveExam, updateExams} from "@/api/training";

export default {
  components: {TJDetailTitle, timePicker, FunctionBox,addExamDialog,updateExamDialog},
  name: 'examList',  // 资产管理列表
  data() {
    return {
      dialogType_dept: '1',
      userRoleId: JSON.parse(localStorage.getItem('userInfo')).org_post,
      addExamDialog: false,
      updateExamDialog: false,
      assetMGtObj:{
        checkExport: false, //盘点导出
      },
      tableSize: '',
      user_id: '',
      page: 1,
      size: 10,
      total: 0,
      loading: false, //加载动画
      tableData: [],
      check_time: [],
      tableHeight: 0,
      searchType: '0',
      message: '',
      searchParams:{
        keywords: '',
        start_time: '',
        end_time: '',
      },
      pageParams:{
        page: 1,
        size:10,
      },
      loadingText: '数据加载中，请稍后',
      examId: null,
    }
  },
  created() {
    this.getTableHeight()
    let menuList = JSON.parse(localStorage.getItem('menuList'))
    addMenu(menuList);
    this.assetMGtObj = getAssetMgtBtn()// 缓存里取按钮权限
    this.getList()
    this.user_id = JSON.parse(localStorage.getItem("userInfo")).user_id
    if(window.innerWidth<1550){
      this.tableSize = 'small'
    }else if(window.innerWidth < 2400 && window.innerWidth > 1550){
      this.tableSize = 'middle'
    }else{
      this.tableSize = 'big'
    }
  },
  methods: {
    // 判断考试是否已经开始,一开始不展示删除按钮
    isStart(row) {
      let now = new Date().getTime()
      let start = new Date(row.start_time).getTime()
      if(now < start){
        return false
      }else if(now > start ) {
        return true
      }
    },
    handleUpdateExam(row){
      this.$router.push({ path: '/cloudTraining/exam/updateExam',query: {id: row.exam_id } })
    },
    getTableHeight(){
      var viewportHeight = window.innerHeight;
      var viewportWidth =  window.innerWidth
      // var element = document.getElementById('pagination');
      if(viewportWidth > 2400){
        this.tableHeight = viewportHeight - 500
      }else if(viewportWidth < 2400 &&  viewportWidth > 1550){
        this.tableHeight = viewportHeight - 400
      }else{
        this.tableHeight = viewportHeight - 600
      }
    },
    getList(){
      this.loading = true
      this.loadingText = '数据加载中，请稍后'
      if(this.searchType != '1' ){   //searchType = '0' 从详情返回的时候，需要获取缓存的搜索条件
        if(sessionStorage.getItem('AcPageParams')){
          this.pageParams = JSON.parse(sessionStorage.getItem('AcPageParams')).pageParams
          this.size = this.pageParams.size || 10
          this.page=this.pageParams.page || 1
        }
        if(JSON.parse(sessionStorage.getItem('AcSearchParams'))){
          this.searchParams = {...JSON.parse(sessionStorage.getItem('AcSearchParams')).searchParams};
          if(this.searchParams && this.searchParams.start_time && this.searchParams.end_time){
            this.check_time = [this.searchParams.start_time,this.searchParams.end_time]
          }else{
            this.check_time = []
          }
        }
      }
      if(this.check_time && this.check_time.length>0){
        this.searchParams.end_time = this.check_time[1]
        this.searchParams.start_time = this.check_time[0]
      }else{
        this.searchParams.end_time = ''
        this.searchParams.start_time = ''
      }
      let params = {
        ...this.searchParams,
        page:  this.pageParams.page,
        size: this.pageParams.size
      }
      getExamList(params).then(res=>{
        this.total = res.data.count
        this.tableData = res.data.data
        this.loading = false
      }).catch(err =>{
        this.loading = false
        if( err.status === 'error' && this.searchParams.page >1 ){
          this.searchParams.page--
          this.getList()
        }
      })
    },

    searchBtn() {  // 搜索
      this.page = 1
      if(this.check_time){
      }else{
        this.searchParams.start_time = ''
        this.searchParams.end_time = ''
      }
      this.searchType = '1'
      this.getList();
      // sessionStorage.setItem('AcSearchParams', JSON.stringify({ searchParams:this.searchParams }));
      // sessionStorage.setItem('AcPageParams', JSON.stringify({ pageParams:{page: 1,size:10} }));
    },
    handleCurrentChange(val) { // 翻页
      this.page = val
      this.pageParams.size = this.size
      this.pageParams.page = this.page
      sessionStorage.setItem('AcPageParams', JSON.stringify({ pageParams:this.pageParams }));
      this.getList('1')
    },
    clearSearch(){  // 重置
      sessionStorage.setItem('AcSearchParams', JSON.stringify({ searchParams:{}}));
      this.searchParams.title = ''
      this.searchParams.note_no = ''
      this.searchParams.note_status = ''
      this.searchParams.start_time = ''
      this.searchParams.end_time = ''
      this.check_time = []
      this.getList('1');

    },
    clearSearchTime(){
      this.searchParams.start_time = ''
      this.searchParams.end_time = ''
      this.check_time = []
      this.getList();
    },
    handleDelete(row){
      const h = this.$createElement
      this.$confirm('提示', {
        title: '提示',
        message: h('div', [h('p', `确认删除这条数据？`),]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteExam({id:row.exam_id}).then(res=>{
          if(res.code == 200){
            this.$message.success('删除成功！')
            this.getList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认',
        })
      })
    },
    handleSizeChange(val){
      this.pageParams.size = val
      this.pageParams.page = this.page
      sessionStorage.setItem('AcPageParams', JSON.stringify({ pageParams:this.pageParams }));
      this.getList('1');
    },

    editCheck(type,row) {
      this.dialogType_dept = type
      if(row && row.exam_id){
        this.examId = Number(row.exam_id)
      }else{
        this.examId = 0
      }
      this.addExamDialog = true
    },
    handleCloseAdd(){
      this.addExamDialog = false
    },
    async handleExamSave(){
      const valid = await this.$refs.addExam.validateForm();
      if (!valid) {
        return; // 校验失败，终止
      }

      let formData = this.$refs.addExam.form
      if(this.examId){
        updateExams({id:this.examId, data:formData}).then(res=>{
          if(res.code == 200){
            this.$message.success('保存成功！')
            this.addExamDialog = false
            this.getList()
          }
        })
      }else{
        saveExam(formData).then(res=>{
          if(res.code == 200){
            this.$message.success('保存成功！')
            this.addExamDialog = false
            this.getList()
          }
        })
      }
    },
    handleClose1(){
      this.addExamDialog = false
    },
    handleClose(){
      this.confirmDialog = false
    },

    handleConfirmSave(){  //

    },
    handleAddExam(){
      this.examId = 0
      this.dialogType_dept = '1'
      this.addExamDialog = true
    },
    handleCheck(row){
      this.$router.push({ path: '/cloudTraining/exam/examRecord',query: {id: row.exam_id } })
    },
    handleAddQuestion(row){
      this.$router.push({ path: '/cloudTraining/question/addQuestBank',query: {note_id: row.note_id,type: 'exam' } })
    }

  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/asset';
::v-deep .el-table th:first-child.el-table__cell>.cell{
  padding-left:14px!important;
}
::v-deep .el-pagination__sizes{
  width: 80px;
  vertical-align: top;
}
::v-deep .el-pagination__sizes .el-select{
  vertical-align: top;
}
::v-deep .el-pagination__sizes input{
  width: 80px;
  height: 1.8rem;
  border: 1px solid #999999;
}
::v-deep .el-pagination .el-input__suffix{
  right: 22px;
}
::v-deep .el-range-editor--small .el-range-input{
  font-size: 0.75rem!important;
}
.export{
  p{
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }
}
.wait{
  background: #9A9A9A;
  color:#fff;
  font-size: px(14);
}
.checking{
  background: #567722;
  color:#fff;
  font-size: px(14);

}
.completed{
  background: #4095E5;
  color:#fff;
  font-size: px(14);
}
.sync-btn{
  color:#fff;
  background: #CBA43F;
}
.train-edit-btn{
  background: #fff;
  border:1px solid #F2995F;
  color: #F2995F;
}
.train-update-btn{
  background: #fff;
  border:1px solid #567722;
  color: #567722;
}
.train-check-btn{
  background: #fff;
  border:1px solid #347CAF;
  color: #347CAF;
}
.train-delete-btn{
  background: #fff;
  border:1px solid #E34D59;
  color: #E34D59;
}
::v-deep .el-dialog__footer{
  text-align: center;
}
::v-deep .el-dialog__header{
  margin: 0 20px;
  border-bottom: 1px solid #eee;
}
.addDialog{
  ::v-deep .el-dialog__body{
    padding: 0 80px!important;
  }
}
</style>
